import { render, staticRenderFns } from "./approval_details.vue?vue&type=template&id=2ab0a8ca&scoped=true&"
import script from "./approval_details.vue?vue&type=script&lang=js&"
export * from "./approval_details.vue?vue&type=script&lang=js&"
import style0 from "./approval_details.vue?vue&type=style&index=0&id=2ab0a8ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0a8ca",
  null
  
)

export default component.exports